const mixin = {
    data(){
        return {
            form:{}
        }
    },
    methods: {
        redirect() {
            plugin.post('/shop/loginAccount',this.form).then(res => {
               if (res.status == 1) {
                    plugin.message(res?.msg,'success')
                    setTimeout(()=>{
                        window.location.reload();
                    },1000)
                }else {
                    plugin.message(res?.msg,'error')
                }
            }).catch(()=>{
                plugin.message('信息错误','error')
            })
            return false;

        }
    }
}
